import { apiAxios } from '../utils/axios';

export const GetNewsDetails = async (shortUri: string) => {
  const url = `/article/${shortUri}`;
  return await apiAxios.get(url);
};
